export class CloneAggregator {
    constructor(field) {
        this._type = 'clone';
        this._field = field;
    }
    get field() {
        return this._field;
    }
    get type() {
        return this._type;
    }
    init() {
        this._data = '';
    }
    accumulate(item) {
        const val = (item && item.hasOwnProperty(this._field)) ? item[this._field] : null;
        if (val !== null && val !== '') {
            this._data = val;
        }
    }
    storeResult(groupTotals) {
        if (!groupTotals || groupTotals[this._type] === undefined) {
            groupTotals[this._type] = {};
        }
        groupTotals[this._type][this._field] = this._data;
    }
}
//# sourceMappingURL=cloneAggregator.js.map